export default "__VITE_ASSET__CcpmRzON__"